import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  JobCardContainer: {
    borderRadius: 6,
    backgroundColor: '#ffffff',
    padding: theme.spacing(3, 3, 5, 3),
    marginBottom: theme.spacing(1.5)
  },
  skillBubbles: {
    backgroundColor: '#e6e6e6',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.2, 1.2),
    display: 'inline-block',
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  skillText: {
    color: '#71767e',
    fontSize: 12
  },
  applyButton: {
    marginTop: theme.spacing(0.5),
    width: theme.spacing(10),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(18)
    }
  },
  jobDescriptionHeader: {
    color: theme.palette.common.black,
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));
